import React from "react";
import ActionButton, { ActionButtonProps } from "../../components/ActionButton";
import HStack from "../../ui_atoms/HStack";
import { View } from "react-native";
import type { Meta, StoryObj } from "@storybook/react";

const meta = {
    title: "Components/ActionButton",
    component: ActionButton,
    argTypes: {
        text: {
            control: { type: "text" },
        },
        textWidth: {
            options: ["bold", "medium"],
            control: { type: "radio" },
        },
        textColor: {
            control: { type: "color" },
        },
        onPress: { action: "pressed the button" },
    },
    args: {
        text: "Press me!",
    },
    decorators: [
        (StoryFn) => (
            <View style={{ flex: 1, justifyContent: "center", alignItems: "center", padding: 10 }}>
                <StoryFn />
            </View>
        ),
    ],
} satisfies Meta<typeof ActionButton>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Simple: Story = {
    args: {
        text: "Press me!",
    },
};

export const WithIconRight: Story = {
    args: {
        text: "This is a very long button with large",
        rightIcon: {
            name: "chevron-down",
            color: "black",
        },
    },
};

export const WithIconLeft: Story = {
    args: {
        text: "This is a very long button with large",
        leftIcon: {
            name: "menu",
            color: "orange",
        },
    },
};

export const MultiLigne: Story = {
    args: {
        text: "This is a very long button with large, This is a very long button with large, This is a very long button with large",
        leftIcon: {
            name: "menu",
            color: "#864381",
        },
        numberOfLines: 2,
    },
};

export const ActionButtonInHStack: Story = ({ text, ...props }: ActionButtonProps) => (
    <HStack gap={0.5} fit="fill">
        <ActionButton {...props} text="This is a lrger title" />
        <ActionButton {...props} text={text} />
    </HStack>
);

ActionButtonInHStack.args = {
    text: "Press me!",
};
